import { getFontFacesCss, determineFontFacesFontDisplay } from '@wix/thunderbolt-becky-root'
import type { Component, FontLoadStrategy } from '@wix/thunderbolt-becky-types'
import { envRefs, themeRefs } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'

export const fontFacesCss = (isEditor: boolean) => {
	return createCssCompNode('fontFaces', 'fontFacesCss', {
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) => ({
			fontFaces: refs.fontFamilies(component),
			publicTopology: envRefs.publicTopology,
			isWixSite: envRefs.isWixSite,
			siteFontDisplay: themeRefs.siteFontDisplay,
		}),
		toViewItem: (__, { fontFaces, publicTopology: { mediaRootUrl }, siteFontDisplay }) => {
			const fontDisplay = determineFontFacesFontDisplay({
				siteFontDisplay,
				isEditor,
			})

			return Array.from(fontFaces).map((fontFamily) =>
				getFontFacesCss([fontFamily], mediaRootUrl, fontDisplay as FontLoadStrategy)
			)
		},
	})
}
